(function () {
    "use strict";

    angular
        .module("app")
        .factory("PermissionService", PermissionService);


    function PermissionService($rootScope, $filter, WebApiService) {

        var service = {
            getAllRoles: getAllRoles,
            getRoleByID: getRoleByID,
            getRolePermissions: getRolePermissions,
            getRolePermissionsAssignment: getRolePermissionsAssignment,
            hasPermission: hasPermission,

            canReadBrief: function () { return hasPermission(3, 1); },
            canEditBrief: function () { return hasPermission(3, 2); },
            canCreateBrief: function () { return hasPermission(3, 3); },

            canReadPattern: function () { return hasPermission(4, 1); },
            canEditPattern: function () { return hasPermission(4, 2); },
            canCreatePattern: function () { return hasPermission(4, 3); },

            canReadPrototype: function () { return hasPermission(5, 1); },
            canEditPrototype: function () { return hasPermission(5, 2); },
            canCreatePrototype: function () { return hasPermission(5, 3); },

            canReadUsers: function () { return hasPermission(6, 1); },
            canEditUsers: function () { return hasPermission(6, 2); },
            canCreateUsers: function () { return hasPermission(6, 3); },

            canReadQuarterlyForecasting: function () { return hasPermission(26, 1); },
            canEditQuarterlyForecasting: function () { return hasPermission(26, 2); },

            canReadQuarterlyForecastingSettings: function () { return hasPermission(27, 1); },
            canEditQuarterlyForecastingSettings: function () { return hasPermission(27, 2); },

            canEditTransferChecklist: function () { return service.canEditPrototype(); }
        };

        return service;

        function getAllRoles() {
            return WebApiService.get("/api/Role/Roles");
        }

        function getRoleByID(roleId) {
            return WebApiService.get("/api/Role/" + roleId);
        }

        function getRolePermissions(roleId) {
            return WebApiService.get("/api/Role/GetRolePermissions?RoleId=" + roleId);
        }

        function getRolePermissionsAssignment(roleId) {
            return WebApiService.get("/api/Role/GetRolePermissionsAssignment?RoleId=" + roleId);
        }

        function hasPermission(moduleId, permissionId) {
            return $filter("filter")($rootScope.userPermissions, function (p) {
                return p[0] === moduleId && p[1] === permissionId;
            }).length > 0;
        }
    }
})();
